/**
 * Combined Notary Public Q&A set (Wave 1 + Wave 2 + Wave 3), de-duplicated by slug.
 * Every /notary question surface (hub, /notary/q/$slug, JSONL feed, sitemap, llms-full)
 * reads from here so a new wave lands everywhere at once.
 */
import { NOTARY_QA, type NotaryQA } from "./questions-500";
import { NOTARY_QA_WAVE2 } from "./questions-wave2";
import { NOTARY_QA_WAVE3 } from "./questions-wave3";
import { NOTARY_QA_WAVE4 } from "./questions-wave4";
import { liftToFloor } from "../_qa/topup-merge";
import { NOTARY_TOPUP_AXIS } from "../_qa/topup-axes";

const merged: NotaryQA[] = [];
const seen = new Set<string>();
for (const qa of [...NOTARY_QA, ...NOTARY_QA_WAVE2, ...NOTARY_QA_WAVE3, ...NOTARY_QA_WAVE4]) {
  if (seen.has(qa.slug)) continue;
  seen.add(qa.slug);
  merged.push(qa);
}

liftToFloor<NotaryQA["cluster"], NotaryQA>(merged, {
  prefix: "notary-t7",
  asOf: "ข้อมูลทบทวน ณ สิงหาคม 2569 รูปแบบการรับรองที่ปลายทางยอมรับเปลี่ยนได้ ควรยืนยันกับผู้รับเอกสารก่อนนัดลงนาม เว็บไซต์ไม่แสดงค่าบริการ ขอใบเสนอราคาเฉพาะเคสได้ทางโทรศัพท์ LINE หรืออีเมล",
  authorityTh: "หน่วยงานหรือสถาบันผู้รับเอกสาร",
  clusterTh: "งานรับรองเอกสารโดยทนายผู้ทำคำรับรอง",
  primary: NOTARY_TOPUP_AXIS,
  clusters: { documents: "documents", process: "process", risk: "legal", location: "location" },
  floor: 3200,
});

export const NOTARY_QA_ALL: NotaryQA[] = merged;

export const NOTARY_QA_ALL_BY_SLUG: Record<string, NotaryQA> = Object.fromEntries(
  NOTARY_QA_ALL.map((q) => [q.slug, q]),
);

/** Total distinct phrasings covered (question + synonym clusters). */
export const NOTARY_QA_PHRASING_COUNT = NOTARY_QA_ALL.reduce(
  (n, qa) => n + 1 + qa.synonyms.length,
  0,
);
